import React, { useEffect, useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
  Radio,
  Button,
  Alert,
  FormLabel,
} from "@mui/material";

import { Card, CardContent, Typography, CardMedia, Box } from "@mui/material";

import "@fontsource/roboto/500.css";
import axiosClient from "../axiosClient";

import { useStateContext } from "../context/ContextProvider";

function ProductsForm(productDetails) {
  const [categories, setCategories] = useState([]);
  const [groups, setGroups] = useState([]);
  const [vats, setVats] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedGroup, setSelectedGroup] = useState();
  const [description, setDescription] = useState();
  const [code, setCode] = useState();
  const [price_one, setPriceOne] = useState();
  const [price_two, setPriceTwo] = useState();
  const [selectedVatOne, setSelectedVatOne] = useState();
  const [selectedVatTwo, setSelectedVatTwo] = useState();
  const [costPrice, setCostPrice] = useState(0);
  const [insert, setInsert] = useState();
  const [selectedType, setSelectedType] = useState();

  const [active, setActive] = useState("true");
  const [discountable, setDiscountable] = useState("true");

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const [preview, setPreview] = useState();
  const [change, onChange] = useState();

  const { store } = useStateContext();

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        onChange(file);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    setLoading(true);
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    axiosClient
      .get(`products/product/options/${databaseStoreName}`)
      .then((response) => {
        setLoading(false);
        setCategories(response.data.categories);
        setGroups(response.data.groups);

        if (Object.keys(productDetails.productDetails).length === 0) {
          setSelectedGroup(response.data.groups[0].id);
          setSelectedCategory(response.data.categories[0].id);
          setSelectedVatOne(1);
          setSelectedVatTwo(1);
          setSelectedType("N");
          setPriceTwo(0)
        }
        setVats(response.data.vats);
      })
      .catch((err) => console.log(err));

    if (Object.keys(productDetails.productDetails).length !== 0) {
      setSelectedCategory(productDetails.productDetails.Category.id);
      setSelectedGroup(productDetails.productDetails.Group.id);
      setDescription(productDetails.productDetails.name);
      setCode(productDetails.productDetails.code);
      if (productDetails.productDetails.photo !== null) {
        setPreview(
          `${process.env.REACT_APP_PHOTO_URL}${databaseStoreName}/${productDetails.productDetails.photo}${productDetails.productDetails.id}.jpg`
        );
      } else {
        setPreview();
      }
      setPriceOne(productDetails.productDetails.price_one);
      setPriceTwo(productDetails.productDetails.price_two);
      setSelectedType(productDetails.productDetails.type);

      if (productDetails.productDetails.Vats.length === 2) {
        const vat_one = productDetails.productDetails.Vats[0].id;
        const vat_two = productDetails.productDetails.Vats[1].id;
        setSelectedVatOne(vat_one);
        setSelectedVatTwo(vat_two);
      } else {
        const vat_one = productDetails.productDetails.Vats[0].id;
        setSelectedVatOne(vat_one);
        setSelectedVatTwo(vat_one);
      }

      setCostPrice(productDetails.productDetails.cost_price);

      if (productDetails.productDetails.duplicate) {
        setActive(productDetails.productDetails.active ? "true" : "false");
        setDiscountable(
          productDetails.productDetails.discountable ? "true" : "false"
        );
        setPreview();
        setInsert(true);
      } else {
        setInsert(false);
      }
    } else {
      axiosClient
        .get(`products/getBarcode/${databaseStoreName}`)
        .then((response) => setCode(response.data.barcode));
      setInsert(true);
    }
  }, [productDetails, store]);

  const handleEdit = () => {
    setLoading(true);
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    var base64Data;
    var binaryData;

    if (preview === null || preview === undefined) {
      base64Data = null;
      binaryData = null;
    } else if (
      typeof preview === "string" &&
      !preview.includes("data:image/jpeg;base64,")
    ) {
      base64Data = "";
      binaryData = "";
    } else {
      base64Data = preview?.split(",")[1]; // Extract the Base64 data
      binaryData = atob(base64Data);
    }

    if (!insert) {
      const payload = {
        params: {
          priceOne: price_one,
          priceTwo: price_two,
          costPrice: costPrice,
          groupId: selectedGroup,
          categoryId: selectedCategory,
          vats: [selectedVatOne, selectedVatTwo],
          productId: productDetails.productDetails.id,
          shopName: databaseStoreName,
          photo: binaryData,
          type: selectedType,
          name: description,
        },
      };

      axiosClient
        .patch("products/product/", payload)
        .then(() => {
          setLoading(false);
          window.location.reload();
        })
        .catch((err) => {
          const errorMessage = err.response.data.err.errors.map((e) => {
            return (
              <>
                {e.message}
                <br></br>
              </>
            );
          });
          setLoading(false);
          setErrorMessage(errorMessage);
        });
    } else {
      const payload = {
        params: {
          code: code,
          name: description,
          active: active === "true" ? 1 : 0,
          discountable: discountable === "true" ? 1 : 0,
          priceOne: price_one,
          priceTwo: price_two,
          type: selectedType,
          costPrice: costPrice,
          groupId: selectedGroup,
          categoryId: selectedCategory,
          vatOneId: selectedVatOne,
          vatTwoId: selectedVatTwo,
          photo: binaryData,
          shopName: databaseStoreName,
        },
      };

      axiosClient
        .post("products/create/", payload)
        .then((data) => {
          setLoading(false);
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          const errorMessage = err.response.data.err.errors.map((e) => {
            return (
              <>
                {e.message}
                <br></br>
              </>
            );
          });
          setLoading(false);
          setErrorMessage(errorMessage);
        });
    }
  };

  const handleEditAndStay = () => {
    setLoading(true);
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    var base64Data;
    var binaryData;

    if (preview === null || preview === undefined) {
      base64Data = null;
      binaryData = null;
    } else if (
      typeof preview === "string" &&
      !preview.includes("data:image/jpeg;base64,")
    ) {
      base64Data = "";
      binaryData = "";
    } else {
      base64Data = preview?.split(",")[1]; // Extract the Base64 data
      binaryData = atob(base64Data);
    }

    const payload = {
      params: {
        code: code,
        name: description,
        active: active === "true" ? 1 : 0,
        discountable: discountable === "true" ? 1 : 0,
        priceOne: price_one,
        priceTwo: price_two,
        type: selectedType,
        costPrice: costPrice,
        groupId: selectedGroup,
        categoryId: selectedCategory,
        vatOneId: selectedVatOne,
        vatTwoId: selectedVatTwo,
        photo: binaryData,
        shopName: databaseStoreName,
      },
    };

    axiosClient
      .post("products/create/", payload)
      .then((data) => {
        axiosClient
          .get(`products/getBarcode/${databaseStoreName}`)
          .then((response) => {
            setCode(response.data.barcode);
            setCostPrice(0);
            setPreview();
            setDescription("");
          });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        const errorMessage = err.response.data.err.errors.map((e) => {
          return (
            <>
              {e.message}
              <br></br>
            </>
          );
        });
        setLoading(false);
        setErrorMessage(errorMessage);
      });
  };

  if (loading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid container direction="row" alignItems="center" spacing={2}>
        {errorMessage && (
          <Grid item xs={12} sm={6}>
            <Alert severity="error" sx={{ marginBottom: 2 }}>
              {errorMessage}
            </Alert>
          </Grid>
        )}
      </Grid>
      <Grid item md={6} lg={6} xs={12}>
        <TextField
          InputLabelProps={{ shrink: true }}
          label="Description"
          autoFocus
          fullWidth
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </Grid>
      <Grid item md={6} lg={6} xs={12}>
        <TextField
          InputLabelProps={{ shrink: true }}
          label="Item code/Bar code"
          fullWidth
          value={code}
          onChange={(e) => setCode(e.target.value)}
          disabled={!insert}
        />
      </Grid>
      <Grid item md={6} lg={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="category-label">Category</InputLabel>
          <Select
            labelId="category-label"
            label="Category"
            value={selectedCategory}
            onChange={(e) => {
              setSelectedCategory(e.target.value);
            }}
          >
            {categories.map((cat) => (
              <MenuItem value={cat.id}>{cat.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item md={6} lg={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="group-label">Group</InputLabel>
          <Select
            labelId="group-label"
            label="Group"
            value={selectedGroup}
            onChange={(e) => {
              setSelectedGroup(e.target.value);
            }}
          >
            {groups.map((group) => (
              <MenuItem value={group.id}>{group.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item md={3} lg={3} xs={12}>
        <TextField
          label="Price 1"
          type="number"
          inputProps={{ step: "0.01", min: 0 }}
          fullWidth
          value={price_one}
          onChange={(e) => {
            setPriceOne(e.target.value);
          }}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item md={3} lg={3} xs={12}>
        <TextField
          label="Price 2"
          type="number"
          inputProps={{ step: "0.01", min: 0 }}
          fullWidth
          value={price_two}
          onChange={(e) => {
            setPriceTwo(e.target.value);
          }}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item md={3} lg={3} xs={12}>
        <TextField
          label="Cost Price"
          type="number"
          inputProps={{ step: "0.01", min: 0 }}
          fullWidth
          value={costPrice}
          onChange={(e) => {
            setCostPrice(e.target.value);
          }}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item md={3} lg={3} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="type">Type</InputLabel>
          <Select
            labelId="type"
            label="type"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            {/* <MenuItem value={"W"}>Weight item</MenuItem> */}
            <MenuItem value={"S"}>Scale item</MenuItem>
            <MenuItem value={"N"}>Normal item</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item md={3} lg={3} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="vat_1">{`VAT 1`}</InputLabel>
          <Select
            labelId="vat_1"
            label="VAT 1"
            value={selectedVatOne}
            onChange={(e) => setSelectedVatOne(e.target.value)}
          >
            {vats.map((v) => (
              <MenuItem value={v.id}>{v.vat}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item md={3} lg={3} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="vat_2">{`VAT 2`}</InputLabel>
          <Select
            labelId="vat_2"
            label="VAT 2"
            value={selectedVatTwo}
            onChange={(e) => setSelectedVatTwo(e.target.value)}
          >
            {vats.map((v) => (
              <MenuItem value={v.id}>{v.vat}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      {insert && (
        <Grid item md={3} lg={3} xs={12}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Active</FormLabel>
            <RadioGroup
              row
              value={active}
              onChange={(e) => setActive(e.target.value)}
            >
              <FormControlLabel value="true" control={<Radio />} label="True" />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label="False"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      )}
      {insert && (
        <Grid item md={3} lg={3} xs={12}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Discountable</FormLabel>
            <RadioGroup
              row
              value={discountable}
              onChange={(e) => setDiscountable(e.target.value)}
            >
              <FormControlLabel value="true" control={<Radio />} label="True" />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label="False"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      )}
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <div className="image-input-container">
          <input
            type="file"
            accept=".jpg"
            onChange={handleChange}
            className="input-file"
          />
          {preview && (
            <img src={preview} alt="Preview" className="preview-image" />
          )}
          {!preview && (
            <div className="placeholder">Click to select an image</div>
          )}
        </div>
        {preview && (
          <Button
            color="error"
            onClick={() => {
              const correctStoreName = JSON.parse(store).name.replace(
                /[^a-zA-Z]/g,
                ""
              );
              const databaseStoreName = `DB301_${
                JSON.parse(store).id
              }_${correctStoreName}`;

              const payload = {
                productId: productDetails.productDetails.id,
                shopName: databaseStoreName,
              };

              axiosClient
                .patch("products/deletePicture", payload)
                .then(() => {
                  setPreview(null);
                })
                .catch((err) => console.log(err));
            }}
          >
            Remove picture
          </Button>
        )}
      </Grid>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <Card
          sx={{
            width: 170,
            height: 120,
            borderRadius: 5,
            overflow: "hidden",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor:
              productDetails.productDetails.color == null
                ? "white"
                : JSON.parse(productDetails.productDetails.color).hex,
            boxShadow: 3,
            margin: 1,
          }}
        >
          {preview ? (
            <>
              <CardMedia
                component="img"
                image={preview}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  width: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  padding: "4px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: "16px",
                  }}
                >
                  {description}
                </Typography>
              </Box>
            </>
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundColor:
                  productDetails.productDetails.color == null
                    ? "white"
                    : JSON.parse(productDetails.productDetails.color).hex,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  color:
                   (productDetails.productDetails.color != null && JSON.parse(productDetails.productDetails.color).hex == "#ffffff") 
                   || (productDetails.productDetails.color == null)
                      ? "#2196F3"
                      : "white",
                  fontSize: "20px",
                  textAlign: 'center'
                }}
              >
                {description}
              </Typography>
            </Box>
          )}
        </Card>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}
        >
          <Button
            variant="contained"
            color="success"
            style={{ marginRight: 16, marginLeft: 16 }}
            onClick={() => handleEdit()}
          >
            {insert ? "Add" : "Save"}
          </Button>
          {insert && (
            <Button
              variant="contained"
              color="success"
              style={{ marginRight: 16, marginLeft: 16 }}
              onClick={() => handleEditAndStay()}
            >
              Add and continue
            </Button>
          )}
          <Button
            variant="contained"
            color="error"
            onClick={() => window.location.reload()}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ProductsForm;
